import React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

export default function PinchZoom({
  initialScale = 1,
  minScale = 0.3,
  maxScale = 5, // 최대 확대 배율
  doubleClickDisabled = true,
  contents,
  wrapperStyle,
  contentStyle,
  componentWrapperStyle,
  componentContentStyle,
}) {
  return (
    <TransformWrapper
      initialScale={initialScale}
      minScale={minScale}
      maxScale={maxScale}
      doubleClick={{ disabled: doubleClickDisabled }} // 더블탭 확대 방지
      wrapperStyle={wrapperStyle}
      contentStyle={contentStyle}
    >
      <TransformComponent
        wrapperStyle={componentWrapperStyle}
        contentStyle={componentContentStyle}
      >
        {contents}
      </TransformComponent>
    </TransformWrapper>
  );
}